import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../../records/grids/columns/columnDefinitionService";
import {
  ColumnDefinitionSetService,
  ColumnDefinitionSetServiceProvider,
  vsProviderName as ColumnDefinitionSetServiceProviderName,
  vsServiceName as ColumnDefinitionSetServiceName,
} from "../../../records/grids/columns/columnDefinitionSetService";
import {
  GridConfiguration,
  RecordGridViewService,
  RecordGridViewServiceProvider,
  vsProviderName as RecordGridViewServiceProviderName,
  vsServiceName as RecordGridViewServiceName,
} from "../../../records/views/recordGridView";
import {
  GridSettingsService,
  vsName as GridSettingsServiceName,
} from "../../../records/grids/settings/gridSettingsService";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../records/server/serverUtility";

import { RecordDataSource } from "../../../records/grids";

import { vsObjectName as machineTypeIdObjectName } from "./machineConfigurationType";

export const vsObjectName = "MachineConfigurationTypeGameConfiguration";

machineGameConfig.$inject = [
  RecordGridViewServiceProviderName,
  ColumnDefinitionSetServiceProviderName,
];
export function machineGameConfig(
  recordGridViewServiceProvider: RecordGridViewServiceProvider,
  columnDefinitionSetServiceProvider: ColumnDefinitionSetServiceProvider
) {
  recordGridViewServiceProvider.addGridConfiguration(vsObjectName, [
    ServerUtilityName,
    GridSettingsServiceName,
    RecordGridViewServiceName,
    (
      serverUtility: ServerUtility,
      gridSettingsService: GridSettingsService,
      recordGridViewService: RecordGridViewService
    ): GridConfiguration => {
      const machineTypeIdGridConfig =
        recordGridViewService.getGridConfiguration(machineTypeIdObjectName);
      return {
        columnDefinitionSet: vsObjectName,
        defaultSort: RecordGridViewService.combineSort(
          machineTypeIdGridConfig?.defaultSort,
          "Order"
        ),
        gridDataSource: new RecordDataSource(
          serverUtility,
          "/api/machines/MachineConfigurationTypeGameConfiguration"
        ),
        gridSettings: gridSettingsService.getGridSettings(Symbol(vsObjectName)),
        namePlural: "Machine Game Configurations",
        nameSingular: "Machine Game Configuration",
        showAddButton: false,
      };
    },
  ]);

  columnDefinitionSetServiceProvider.addColumnDefinitionSet(vsObjectName, [
    ColumnDefinitionServiceName,
    ColumnDefinitionSetServiceName,
    (
      columnDefinitionService: ColumnDefinitionService,
      columnDefinitionSetService: ColumnDefinitionSetService
    ) => {
      const cols = [
        columnDefinitionService.getNumberColDef({
          field: "Id",
          hide: true,
        }),
        columnDefinitionService.getStringColDef({
          field: "MachineThemeName",
          header: "Theme",
        }),
        columnDefinitionService.getStringColDef({
          field: "MachineDenominationName",
          header: "Denomination",
        }),
        columnDefinitionService.getNumberColDef({
          field: "MachineDenominationValue",
          header: "Denomination Value",
          hide: true,
        }),
        columnDefinitionService.getNumberColDef({
          field: "Par",
          header: "Par",
        }),
        columnDefinitionService.getNumberColDef({
          field: "MaxCoin",
          header: "Max Coin",
        }),
        columnDefinitionService.getNumberColDef({
          field: "FirstCoin",
          header: "First Coin",
        }),
        columnDefinitionService.getNumberColDef({
          field: "MaxMachPay",
          header: "Max Mach Pay",
        }),
        columnDefinitionService.getNumberColDef({
          field: "MaxCoins",
          header: "Max Coins",
        }),
        columnDefinitionService.getNumberColDef({
          field: "MinBet",
          header: "Min Bet",
        }),
        columnDefinitionService.getNumberColDef({
          field: "MaxBet",
          header: "Max Bet",
        }),
        columnDefinitionService.getNumberColDef({
          field: "Payline",
        }),
        columnDefinitionService.getNumberColDef({
          field: "NetWin",
          header: "Net Win",
        }),
        columnDefinitionService.getNumberColDef({
          field: "CoinIn",
          header: "Coin In",
        }),
        columnDefinitionService.getNumberColDef({
          field: "DailyFee",
          header: "Daily Fee",
        }),
        columnDefinitionService.getBooleanColDef({
          field: "Wap",
        }),
        columnDefinitionService.getStringColDef({
          field: "PaytableId",
          header: "Paytable ID",
        }),
        ...columnDefinitionSetService.getColumnDefinitionSet(
          machineTypeIdObjectName
        ),
      ];

      return cols;
    },
  ]);
}
